import { useFormik } from "formik";
import React, { useState } from "react";
import { Button } from "react-bootstrap-v5";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Loader from "../../Components/Loader";
import BlogService from "../../Services/BlogService";
import CropImageDialog from "../WebLinkRetailer/CropImageDialog";
import "../WebLinkRetailer/box.css";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";

const AddBlog = ({ setAddModal, getBlogs }) => {
  const [loader, setLoader] = useState(false);
  const [image, setImage] = useState("");
  const [cropModal, setCropModal] = useState(false);
  const [valimg, setValimg] = useState(false);

  const history = useHistory();

  const formik = useFormik({
    initialValues: {
      image: "",
      title: "",
      description: "",
    },

    validationSchema: Yup.object({
      image: Yup.string().required("Required"),
      title: Yup.string().required("Required"),
      description: Yup.string().required("Required"),
    }),

    onSubmit: (values) => {
      let data = new FormData();

      data.append("image", formik.values.image);
      data.append("title", formik.values.title);
      data.append("description", formik.values.description);

      setLoader(true);
      BlogService.addBlog(data)
        .then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            setAddModal(false);
            setLoader(false);
            getBlogs();
          } else {
            toast.error(res.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
  } = formik;

  const editorConfig = {
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "italic",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        // 'link',
        "undo",
        "redo",
      ],
    },
  };

  console.log(values, "values")

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              {image.imageurl && (
                <div className="mb-3 row">
                  <div className="col-12">
                    <div className="box-img ">
                      <div className="retailer-images">
                        <img src={image.imageurl} />
                      </div>
                    </div>

                    {cropModal && (
                      <CropImageDialog
                        cropModal={cropModal}
                        setCropModal={setCropModal}
                        imagedata={image}
                        setNewImage={setImage}
                        setFieldValue={formik.setFieldValue}
                      />
                    )}
                  </div>
                </div>
              )}

              <div className="mb-3 row mt-2">
                <div className="col-12 mb-3">
                  <input
                    required={false}
                    type="file"
                    className={
                      "form-control" +
                      (formik.touched.image
                        ? !formik.errors.image
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    onChange={(e) => {
                      if (e.target.files[0].name.split(".").at(-1) === "svg") {
                        setValimg(true);
                      } else {
                        setValimg(false);
                        formik.setFieldValue(
                          "image",
                          e.target.files[0]
                        );
                        setImage({
                          imageurl: URL.createObjectURL(e.target.files[0]),
                          image: e.target.files,
                        });
                      }
                    }}
                  />
                  {valimg === true && (
                    <p className="text-danger">
                      Uploaded file has unsupported format
                    </p>
                  )}
                  {formik.touched.image &&
                  formik.errors.image ? (
                    <div className="text-danger">
                      {formik.errors.image}
                    </div>
                  ) : null}
                </div>
                {image.imageurl && (
                  <div className="text-end col-12 mt-3 mb-3">
                    <Button
                      style={{ width: "95px" }}
                      onClick={() => setCropModal(true)}
                    >
                      crop
                    </Button>
                  </div>
                )}
                <div className="col-12 mb-3">
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.touched.title
                        ? !formik.errors.title
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("title")}
                    placeholder="Enter Title"
                  />
                  {formik.touched.title && formik.errors.title ? (
                    <div className="text-danger">{formik.errors.title}</div>
                  ) : null}
                </div>
                <div className="col-12 mb-3">
                  {/* <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.touched.description
                        ? !formik.errors.description
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("description")}
                    placeholder="Enter description"
                  /> */}
                  <CKEditor
                    editor={ClassicEditor}
                    config={{
                      ...editorConfig,
                      placeholder: "Write your blog here...",
                    }}
                    {...getFieldProps("Description")}
                    onChange={(event, editor) => {
                      setFieldValue("description", editor.getData());
                    }}
                    onFocus={(event, editor) => {
                      // console.log("Focus.", editor);
                    }}
                    onBlur={(event, editor) => {
                      // console.log("Blur.", editor);
                    }}
                    helperText={
                      formik.touched.description && formik.errors.description
                    }
                    error={Boolean(
                      formik.errors.description && formik.touched.description
                    )}
                  />
                  {formik.touched.description && formik.errors.description ? (
                    <div className="text-danger">
                      {formik.errors.description}
                    </div>
                  ) : null}
                </div>
              </div>
              {/* {/ </div> /} */}
              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => setAddModal(false)}
                  // onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
              {/* {/ <ImageCropper/> /} */}
            </form>
            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBlog;
